module.exports = __webpack_public_path__ + "img/icon_38.577c2a89.png";